import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchTaxes(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/taxes', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchTax(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/taxes/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addTax(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/taxes`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteTax(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/taxes/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateTax(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/taxes/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}